import React from 'react'
import ReactDOM from 'react-dom'
import DatePicker from 'react-datepicker'

const PopperContainer = ({ children }) => ReactDOM.createPortal(children, document.body)

/**
 * DatePicker para modais: popup pequeno junto ao campo, com mês/ano e digitação manual.
 * O popper vai para o body só para ficar acima do editor (z-index), sem overlay em tela cheia.
 */
const ModalDatePicker = (props) => (
  <DatePicker
    locale="pt-BR"
    className="form-control"
    dateFormat="dd/MM/yyyy"
    placeholderText="__/__/_____"
    peekNextMonth
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"
    popperContainer={PopperContainer}
    popperClassName="official-letters-datepicker-popper"
    calendarClassName="official-letters-datepicker"
    popperModifiers={{
      preventOverflow: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport',
      },
    }}
    {...props}
  />
)

export default ModalDatePicker
